
import packageJson from '../../package.json';
const cYear = new Date().getFullYear();
const currentApplicationVersion = packageJson.version;

export default function Footer(){
    return( <div className="footer">
        <div>Copyright © {cYear} Earth-i Ltd. All rights reserved. (ver: {currentApplicationVersion})</div>
      </div>)
}